module.exports = __webpack_public_path__ + "img/menuicon-106-active.a3896e25.png";